import styled from "styled-components";
import { i18n } from "../../../services/i18nService";
export const LabelStyled = styled.span`
  height: 2.438rem;
  width: 7.563rem;
  color: rgba(255, 255, 255, 0.5);
  font-family: ${props =>
    props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "URW Geometric Arabic" : "impact"};
  font-size: 2rem;
  ${props =>
    props.theme.locale.dir !== i18n.directions.RIGHT_TO_LEFT ? " letter-spacing: 0.25rem;" : "letter-spacing: 0.03rem;"}
  line-height: 2.438rem;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
  ${props => props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT && " font-weight: 900"}
`;

export const LabelWrapperStyled = styled.div`
  position: absolute;
  text-transform: uppercase;
  top: 53rem;
  ${props =>
    `${props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "left" : "right"} :
         ${!props.brandName ? "3rem" : props.theme.locale.dir === i18n.directions.LEFT_TO_RIGHT ? "15rem" : "25rem"} 
    }`}
  z-index: 99999;
`;
